import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetLookupEtiquetaResponse } from '../../responses/etiqueta/get-lookup-etiqueta.response';
import { ListEtiquetaSelectResponse } from '../../responses/etiqueta/list-etiqueta-select.response';

@Injectable({
  providedIn: 'root',
})
export class EtiquetaLookupService extends CommonService {
  private readonly apiUrl: string = environment.urlApiEtiqueta + 'Lookup';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getLookup(idTipoEtiqueta?: number): Observable<GetLookupEtiquetaResponse> {
    const url = `${this.apiUrl}/getLookup`;
    let params = new HttpParams();

    if (idTipoEtiqueta) {
      params = params.set('idTipoEtiqueta', idTipoEtiqueta.toString());
    }

    return this.httpClient
      .get<GetLookupEtiquetaResponse>(url, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public getCamposByTipoEtiqueta(
    idTipoEtiqueta: number
  ): Observable<GetLookupEtiquetaResponse> {
    const url = `${this.apiUrl}/tiposEtiquetaCampo/${idTipoEtiqueta}`;

    return this.httpClient
      .get<GetLookupEtiquetaResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public listEtiquetaSelect(textoBusca?: string, idTipoEtiqueta?: number): Observable<ListEtiquetaSelectResponse> {
    const url = `${this.apiUrl}/listEtiquetaSelect`;
    let params = new HttpParams();

    if (textoBusca) {
      params = params.set('textoBusca', textoBusca);
    }

    if (idTipoEtiqueta) {
      params = params.set('idTipoEtiqueta', idTipoEtiqueta.toString());
    }

    return this.httpClient
      .get<ListEtiquetaSelectResponse>(url, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }
}
